import styled from 'styled-components';

export const SectionContainer = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 0 48px;

    & > * {
        flex: 1 1 calc(50% - 48px);

        @media screen and (max-width: 950px) {
            width: 100%;
        }

        &:last-child {
            max-width: calc(50% - 24px);
            margin: 0 0 32px 0;

            @media screen and (max-width: 950px) {
                max-width: 100%;
            }
        }
    }

    input[disabled] {
        cursor: default;
    }

    @media screen and (max-width: 950px) {
        flex-direction: column;
    }
`;
